export default "/images/ChristineDücker.jpg?5488000217762795eedb9cda7050328f";